import { KeyValue } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Order } from 'src/app/core';

/**
 * Update keyvalue object on sorting change
 */
@Pipe({
  name: 'sortMap'
})
export class SortMapPipe implements PipeTransform {

  transform(
    arr: KeyValue<string, any>[],
    orderBy: Order = null,
    initArr: KeyValue<string, any>[] = null,
  ): KeyValue<string, any>[] {
    if (orderBy === Order.ASC) {
      return arr.sort((a, b) => a.key.localeCompare(b.key));
    }

    if (orderBy === Order.DESC) {
      return arr.sort((a, b) => b.key.localeCompare(a.key));
    }

    return initArr ? Object.entries(initArr).map(([key, value]) => ({ key, value })) : arr;
  }

}
